












































































import Vue from 'vue';

interface FormValues {
  email: string;
  password: string;
}

export default Vue.extend({
  data() {
    return {
      form: this.$form.createForm(this),
    };
  },

  methods: {
    handleSubmit() {
      this.form.validateFields((errors: Error[], values: FormValues) => {
        if (errors === null) {
          this.$coreApp.auth.signIn(
            values.email,
            values.password,
            (err, user, next) => {
              if (err) {
                console.error(err); // tslint:disable-line no-console
                this.$message.error(`Unable to sign in: ${err.message}`);
              } else {
                this.$message.success('Signed in');
                this.$store.commit('setUser', user);
              }
              if (next) {
                this.$router.replace(next);
              }
            },
          );
        }
      });
    },
  },
});
